<h3 mat-dialog-title>State-Level Data Access Request</h3>


<mat-dialog-content class="dialog-content">
  @if (data.message) {
  <p>{{ data.message }}</p>
  }
  <mat-form-field class="wide" appearance="outline">
    <mat-label>Add State/Territory</mat-label>
    <input type="text" matInput [formControl]="filterControl" [matAutocomplete]="autoComplete" />
    <mat-autocomplete #autoComplete="matAutocomplete" (optionSelected)="addState($event)" [displayWith]="displayFn">
      @for (territory of filteredTerritories$ | async; track territory.id) {
      <mat-option [value]="territory">{{ territory.name }}</mat-option>
      }
      @if( (filteredTerritories$ | async)?.length === 0 && filterControl.value) {
      <mat-hint>No states found matching "{{ filterControl.value
        }}"</mat-hint>
      }
    </mat-autocomplete>
  </mat-form-field>

  <mat-chip-set class="chip-set">
    @for (state of selectedStates | async; track state.id) {
    <mat-chip (removed)="removeState(state)">
      {{ state.name }}
      <button matChipRemove [attr.aria-label]="'Remove ' + state.name">
        <mat-icon>cancel</mat-icon>
      </button>
    </mat-chip>
    }
  </mat-chip-set>

  <mat-form-field class="wide" appearance="outline">
    <mat-label>Reason for access</mat-label>
    <textarea matInput rows="4" [formControl]="justificationControl"></textarea>
    @if (justificationControl.touched && justificationControl.invalid) {
    <mat-error>Reason for access is required.</mat-error>
    }
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions class="dialog-actions" align="end">
  <button mat-stroked-button (click)="cancel()" cdkFocusInitial>Cancel</button>
  <button mat-flat-button color="primary" (click)="submit()"
    [disabled]="justificationControl.invalid || (selectedStates | async)?.length === 0">
    Submit
  </button>
</mat-dialog-actions>
